import React, { useState } from 'react';
import './AddToIndentModal.css';

const AddToIndentModal = ({ isOpen, onClose, medicine, onAddToIndent, onAddToSpecialIndent }) => {
  const [quantity, setQuantity] = useState(1);
  const [cost, setCost] = useState('');
  const [rate, setRate] = useState('');
  const [specialInstructions, setSpecialInstructions] = useState('');
  const [ward, setWard] = useState('');
  const [issueDate, setIssueDate] = useState('');
  const [dockerNumber, setDockerNumber] = useState('');
  const [requestDate, setRequestDate] = useState('');

  const handleAddToIndent = () => {
    const indentData = {
      ward,
      issueDate,
      dockerNumber,
      requestDate,
      medicineName: medicine.name,
      batchNumber: medicine.batchNumber,
      quantity,
      cost,
      rate,
    };
    onAddToIndent(indentData); // Pass data to parent
    onClose(); // Close modal after adding to indent
  };

  const handleAddToSpecialIndent = () => {
    const specialIndentData = {
      ward,
      issueDate,
      dockerNumber,
      requestDate,
      medicineName: medicine.name,
      batchNumber: medicine.batchNumber,
      specialInstructions,
    };
    onAddToSpecialIndent(specialIndentData); // Pass data to parent
    onClose(); // Close modal after adding to special indent
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-addtoindent">
      <div className="modal-content-addtoindent">
        <h1 className="indentformheader">Add to Indent</h1>

        {/* Ward Details Section */}
        <div className="modal-form-input">
          <label htmlFor="ward">Ward</label>
          <input
            id="ward"
            type="text"
            value={ward}
            onChange={(e) => setWard(e.target.value)}
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="issueDate">Issue Date</label>
          <input
            id="issueDate"
            type="date"
            value={issueDate}
            onChange={(e) => setIssueDate(e.target.value)}
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="dockerNumber">Docker Number</label>
          <input
            id="dockerNumber"
            type="text"
            value={dockerNumber}
            onChange={(e) => setDockerNumber(e.target.value)}
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="requestDate">Request Date</label>
          <input
            id="requestDate"
            type="date"
            value={requestDate}
            onChange={(e) => setRequestDate(e.target.value)}
            required
          />
        </div>

        {/* Medicine Details Section */}
        <div className="modal-form-input">
          <label htmlFor="medicineName">Medicine Name</label>
          <input
            id="medicineName"
            type="text"
            value={medicine.name}
            readOnly
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="batchNumber">Batch Number</label>
          <input
            id="batchNumber"
            type="text"
            value={medicine.batchNumber}
            readOnly
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="quantity">Issue Quantity</label>
          <input
            id="quantity"
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="1"
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="cost">Cost</label>
          <input
            id="cost"
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            min="0"
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="rate">Rate/Unit</label>
          <input
            id="rate"
            type="number"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            min="0"
            required
          />
        </div>

        <div className="modal-form-input">
          <label htmlFor="specialInstructions">Special Instructions</label>
          <textarea
            id="specialInstructions"
            value={specialInstructions}
            onChange={(e) => setSpecialInstructions(e.target.value)}
          />
        </div>

        <div className="modal-buttons-addtoindent">
          <button className="btn-add-to-indent" onClick={handleAddToIndent}>
            Add to Indent
          </button>
          <button className="btn-add-to-special-indent" onClick={handleAddToSpecialIndent}>
            Add to Special Indent
          </button>
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToIndentModal;
